export const GET_CATEGORIES_REQUEST = 'CATEGORY_GET_CATEGORIES_REQUEST';
export const GET_CATEGORIES_SUCCESS = 'CATEGORY_GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAILURE = 'CATEGORY_GET_CATEGORIES_FAILURE';
export const SHOW_CATEGORY = 'CATEGORY_SHOW_CATEGORY';
export const HIDE_CATEGORY = 'CATEGORY_HIDE_CATEGORY';
export const TOGGLE_CATEGORY = 'CATEGORY_TOGGLE_CATEGORY';
